import React, { ReactNode } from "react";

import TraceableIdentifierLink from "./TraceableIdentifierLink";

type TraceableBarcodeProps = {
  barcode: string | number | null | undefined;
  displayValue?: ReactNode;
  className?: string;
  valueClassName?: string;
};

export function buildBarcodeHistoryPath(barcode: string | number) {
  const searchParams = new URLSearchParams({ barcode: String(barcode) });
  return `/barcode-history?${searchParams.toString()}`;
}

/** A barcode that opens its lifecycle history while retaining the copy action. */
export default function TraceableBarcode({
  barcode,
  displayValue,
  className,
  valueClassName,
}: TraceableBarcodeProps) {
  return (
    <TraceableIdentifierLink
      value={barcode}
      description="full barcode"
      buildPath={buildBarcodeHistoryPath}
      buildTitle={(value) => `View barcode history for ${value}`}
      displayValue={displayValue}
      className={className}
      valueClassName={valueClassName}
    />
  );
}
